import type {Travel, TooltipTextsProps} from '../types/travel'
import '../styles/components/TravelCard.css'
import {Highlight} from "./Highlight.tsx";
import {WishlistLink} from "./WishlistLink.tsx";
import {Pill} from "./Pill.tsx";
import {AccommodationIcon} from "./AccommodationIcon.tsx";
import {DifficultyLevels} from "./DifficultyLevels.tsx";
import {formatGermanPrice} from "../utils/priceFormatter";
import {decodeHtmlEntities} from "../utils/htmlUtils.ts";
import {accommodationItemsMapping} from "../utils/accommodationMapping.ts";

interface TravelCardProps {
    travel: Travel
    toolTipTexts?: TooltipTextsProps
}

export function TravelCard({travel, toolTipTexts}: TravelCardProps) {
    const {
        id,
        title,
        preis,
        dauer,
        image,
        //hauptland,
        difficulty,
        difficultyValue = 0,
        fromPrice,
        url,
        //icon,
        kontinent,
        unterkunft,
        reiseart,
        flug,
        empfehlung,
        hauptregionen
    } = travel

    const colorClass = "region-" + (kontinent && kontinent[0] ? kontinent[0].toLowerCase() : "");


    // @ts-ignore
    return (
        <div className="journey-tile" data-id={{id}}>

            {/*
                In ep-themes.class.php folgende methoden wurden verwendet:
                -> is_new_post_badge
                -> is_highlight_post_badge
                -> get_reise_regionen_color
                -> get_tent_or_bed
                -> get_difficulty_level
                -> build_reise_walking_days_texts
                -> get_from_price
            */}

            <div className="image-wrapper">

                {empfehlung && (
                    <div className="badge-wrapper">
                        {(empfehlung === 'Highlight-Reise') && (<Highlight text="Highlight" cssClasses="small highlight-white"/>)}
                        {(empfehlung === 'Neue Reise') && (<Highlight text="Neu" cssClasses="small highlight-red"/>)}
                    </div>
                )}

                {/*Todo Vinz - wishlist add functionality */}
                <WishlistLink
                    postId={id}
                    showTitle={false}
                />

                <a href={url}>
                    <img src={image || '/placeholder-travel.jpg'} alt={title} className="w-[600px] h-[750px] object-cover"/>
                </a>
            </div>


            <div className="meta-wrapper journey-type">

                {hauptregionen && (
                    <>
                        <div className="main-country flex gap-1 flex-wrap lg:flex-nowrap">

                            {hauptregionen?.data?.map(item => (
                                <Pill
                                    title={item.name}
                                    colorClass={item.color_class}
                                    targetUrl={item.landingpage_url}
                                />
                            ))}

                            {hauptregionen?.regionen_count_gt_1 && (
                                <Pill
                                    title={`+ ${hauptregionen.regionen_count_gt_1}`}
                                    colorClass={colorClass}
                                />
                            )}
                        </div>

                        {accommodationItemsMapping(unterkunft).map(item => {
                            const toolTipText = (toolTipTexts && toolTipTexts.travel && toolTipTexts.travel[item]) ? toolTipTexts.travel[item] : '';
                            return (<AccommodationIcon
                                icon={item ?? 'Hotel'}
                                colorClass={colorClass}
                                toolTipText={toolTipText}
                            />)
                        })}
                    </>
                )}
            </div>

            <div className="h5">{dauer} TAGE {reiseart?.includes("Familienreise") ? `FAMILIENREISE` : `WANDERREISE`}</div>

            <div className="h3"><a href={url}>{decodeHtmlEntities(title)}</a></div>

            <div className="level">

                <DifficultyLevels
                    difficulty={difficulty}
                    difficultyValue={difficultyValue}
                    variant={0}
                />

            </div>

            <div className="price">

                {/*
                    Todo Vinz Flight text possibilities
                    1. "-"
                    2. "Person, inkl. Flug"
                    3. "Person, exkl. Flug"
                    4. "Person, kein Flug"
                */}

                <strong>ab € {formatGermanPrice(fromPrice || preis)}</strong> <span>/ Person{flug && `, ${flug}`}</span>
            </div>
        </div>
    )
}
